import * as styles from './styles.css';

interface IContentProps {
  child: JSX.Element;
}

export const Content: React.FC<IContentProps> = ({ child }) => {
  return <div className={styles['container']}>{child}</div>;
};
